module.exports = __webpack_public_path__ + "img/8.1e11d668.jpg";